import React from 'react';
import { useParams } from 'react-router-dom';
import { Groups } from '../projects/Groups';
import ProjectPreview from '../components/ProjectPreview';

function GroupPage() {
  let groupParam = useParams();
  let curGroup = Groups.find(item => item.link === groupParam.group)
  let groupTitle = curGroup.title;
  let groupProjects = curGroup.projects;
  
  return (
    <div className="GroupPage">
      <h2>{groupTitle}</h2>
      <div className="GroupProjects">
        {groupProjects.map((groupProject, index) => (
          <ProjectPreview key={index} project={groupProject} />
        ))}
      </div>
    </div>
  );
}

export default GroupPage;